import Cookies from "js-cookie";

const TokenKey = "FangMao-Token";

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

const UserIdKey = "FangMao-UserId";

export function getUserId() {
  return Cookies.get(UserIdKey);
}

export function setUserId(UserId) {
  return Cookies.set(UserIdKey, UserId);
}

export function removeUserId() {
  return Cookies.remove(UserIdKey);
}

const SiteIdKey = "FangMao-SiteId";

export function getSiteId() {
  return Number(Cookies.get(SiteIdKey)) ? Number(Cookies.get(SiteIdKey)) : 0;
}

export function setSiteId(SiteId) {
  return Cookies.set(SiteIdKey, SiteId);
}

export function removeSiteId() {
  return Cookies.remove(SiteIdKey);
}
